class SubmenuMenu extends HTMLElement {
  constructor() {
    super();

    this.debouncedCheckOverflow = debounce((event) => {
      this.checkOverflow(event);
    }, 200);
    this.bindOnMouseDown = this.onMouseDown.bind(this);
    this.bindOnMouseUp = this.onMouseUp.bind(this);
    this.bindOnMouseMove = this.onMouseMove.bind(this);
  }

  connectedCallback() {
    if (!this.hasAttribute('swipe')) return;

    this.scrollContainer = this.querySelector('ul');

    if (!this.scrollContainer) return;

    this.handleScroll();
    this.checkOverflow();
    window.addEventListener('resize', this.debouncedCheckOverflow);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.debouncedCheckOverflow);
    this.scrollContainer?.removeEventListener('mousedown', this.bindOnMouseDown);
  }

  handleScroll() {
    this.isDown = false;
    this.startX = 0;
    this.initScrollLeft = this.scrollContainer.scrollLeft;

    this.scrollContainer.addEventListener('mousedown', this.bindOnMouseDown, { passive: false });
  }

  onMouseDown(event) {
    event.preventDefault();
    this.scrollContainer.classList.add('grabbing');
    this.isDown = true;
    this.startX = event.pageX - this.scrollContainer.offsetLeft;
    this.initScrollLeft = this.scrollContainer.scrollLeft;

    this.scrollContainer.addEventListener('mouseleave', this.bindOnMouseUp, { passive: false });
    this.scrollContainer.addEventListener('mouseup', this.bindOnMouseUp, { passive: false });
    this.scrollContainer.addEventListener('mousemove', this.bindOnMouseMove, { passive: false });
  }

  onMouseMove(event) {
    event.preventDefault();
    if (!this.isDown) return;
    this.scrollContainer.classList.add('moving');
    const x = event.pageX - this.scrollContainer.offsetLeft;
    const walk = x - this.startX;
    this.scrollContainer.scrollLeft = this.initScrollLeft - walk;
  }

  onMouseUp() {
    this.isDown = false;
    this.scrollContainer.classList.remove('grabbing', 'moving');

    this.scrollContainer.removeEventListener('mouseleave', this.bindOnMouseUp, { passive: false });
    this.scrollContainer.removeEventListener('mouseup', this.bindOnMouseUp, { passive: false });
    this.scrollContainer.removeEventListener('mousemove', this.bindOnMouseMove, { passive: false });
  }

  checkOverflow() {
    const children = Array.from(this.scrollContainer.children);
    const childrenWidth = children.reduce((sum, child) => (sum + child.getBoundingClientRect().width), 0);
    const computedStyle = getComputedStyle(this.scrollContainer)
    const gap = parseFloat(computedStyle.columnGap || computedStyle.gap || 0);
    const gapWidth = (children.length - 1) * gap;

    const containerWidth = (childrenWidth + gapWidth);

    if (this.scrollContainer.clientWidth < containerWidth) this.scrollContainer.classList.add('overflowed');
    else this.scrollContainer.classList.remove('overflowed');
  }
}

if (!customElements.get('submenu-menu')) {
  customElements.define('submenu-menu', SubmenuMenu);
}
